import React, { useEffect, useState } from 'react'
import { Map, Marker, Polyline, TileLayer, ZoomControl } from 'react-leaflet'
import 'leaflet/dist/leaflet.css';

import goal from '../images/goal.png';
import start from '../images/start.png';
import Leaflet from 'leaflet';
Leaflet.Icon.Default.imagePath = '//cdnjs.cloudflare.com/ajax/libs/leaflet/1.3.1/images/';

const goalIcon = Leaflet.icon({
  iconUrl: goal,
  iconSize: [18, 18],
});

const startIcon = Leaflet.icon({
  iconUrl: start,
  iconSize: [18, 18],
});

const styles = {
  width: "20rem",
  height: "16rem"
};

const RouteMap = (props) => {

  const [center, setCenter] = useState(props.routes[0]);
  const mapSize = 15;

  useEffect(() => {
    const max = [-90, -180];
    const min = [90, 180];
    for(let i=0;i<props.routes.length;i++){
      if(props.routes[i][0]>max[0]){
        max[0]=props.routes[i][0];
      }
      if(props.routes[i][0]<min[0]){
        min[0]=props.routes[i][0];
      }
      if(props.routes[i][1]>max[1]){
        max[1]=props.routes[i][1];
      }
      if(props.routes[i][1]<min[1]){
        min[1]=props.routes[i][1];
      }
    }
    setCenter([(min[0]+max[0])/2,(min[1]+max[1])/2]);
  },[props.routes]);

  return(
    ((props.routes.length>1)?
    <Map center={center} style={styles} zoomControl={false} zoom={mapSize} dragging={true} 
    touchZoom={true} scrollWheelZoom={false} doubleClickZoom={false} boxZoom={false} tap={false} keyboard={false}>
      <TileLayer
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        attribution="&copy; <a href=&quot;http://osm.org/copyright&quot;>OpenStreetMap</a> contributors"
      />
      <Marker position={props.routes[0]} icon={startIcon}></Marker>
      <Marker position={props.routes[props.routes.length-1]} icon={goalIcon}></Marker>
      <ZoomControl position={"bottomleft"}></ZoomControl>
      <Polyline positions={props.routes} />
    </Map>
    :<div style={styles}>位置情報が提供されなかったので，経路情報，消費カロリー，走行タイムはご利用になれません．</div>)
  )
}

export default RouteMap;
